/**
 * ProofAllowanceChip — calm reusable balance pill.
 *
 * Renders nothing when `balance.show_balance_to_user === false`
 * (the fast_track invisible-tracking path). Otherwise shows the
 * remaining proof analyses for the period in operator-locked tone:
 *
 *   "3 proof analyses left this period"
 *   "Out of proof credits — your upload is saved"
 *
 * Pure visual component. The owning surface decides whether to
 * fetch /api/proof-entitlements/me and how often.
 */
import { ShieldCheck, Coins } from "lucide-react";


export default function ProofAllowanceChip({ balance, dense = false }) {
  if (!balance || !balance.show_balance_to_user) return null;
  const total = Number(balance.total_balance || 0);
  const empty = total <= 0;
  const label = empty
    ? "Out of proof credits"
    : `${total} proof ${total === 1 ? "analysis" : "analyses"} left`;
  const sub = empty ? "Your upload is saved" : "this period";
  const Icon = empty ? Coins : ShieldCheck;
  const palette = empty
    ? "bg-amber-50 text-amber-900 border-amber-300"
    : "bg-emerald-50 text-emerald-900 border-emerald-300";
  return (
    <div
      className={`inline-flex items-center gap-2 border rounded-full ${palette} ${dense ? "px-2.5 py-0.5" : "px-3 py-1"}`}
      data-testid="proof-allowance-chip"
      data-balance={total}
      data-empty={empty ? "true" : "false"}
    >
      <Icon size={dense ? 12 : 14} />
      <span className={`font-semibold ${dense ? "text-[11px]" : "text-xs"}`}>
        {label}
      </span>
      <span className={`opacity-70 ${dense ? "text-[10px]" : "text-[11px]"}`}>
        · {sub}
      </span>
    </div>
  );
}
